import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FreeTrialToastState {
  isVisible: boolean;
  message?: string;
  route?: string;
  routeLabel?: string;
  autoClose?: boolean;
}

const initialState: FreeTrialToastState = {
  isVisible: false,
  message: undefined, // Now using localized messages
  route: "/portal",
  routeLabel: undefined, // Now using localized labels
  autoClose: false,
};

const freeTrialToastSlice = createSlice({
  name: "freeTrialToast",
  initialState,
  reducers: {
    showToast: (state, action: PayloadAction<Partial<FreeTrialToastState>>) => {
      state.isVisible = true;
      if (action.payload.message !== undefined) {
        state.message = action.payload.message;
      }
      if (action.payload.route !== undefined) {
        state.route = action.payload.route;
      }
      if (action.payload.routeLabel !== undefined) {
        state.routeLabel = action.payload.routeLabel;
      }
      if (action.payload.autoClose !== undefined) {
        state.autoClose = action.payload.autoClose;
      }
    },
    hideToast: (state) => {
      state.isVisible = false;
    },
    setToastConfig: (state, action: PayloadAction<Partial<Omit<FreeTrialToastState, 'isVisible'>>>) => {
      if (action.payload.message !== undefined) {
        state.message = action.payload.message;
      }
      if (action.payload.route !== undefined) {
        state.route = action.payload.route;
      }
      if (action.payload.routeLabel !== undefined) {
        state.routeLabel = action.payload.routeLabel;
      }
      if (action.payload.autoClose !== undefined) {
        state.autoClose = action.payload.autoClose;
      }
    },
  },
});

export const { showToast, hideToast, setToastConfig } = freeTrialToastSlice.actions;
export default freeTrialToastSlice.reducer; 